import React, { useState } from "react";
import {
    Avatar,
    Box,
    Button,
    Card,
    CardContent,
    Drawer,
    Grid,
    Typography,
} from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined';
import SearchProfile from "views/alumniSearchProfile/SearchProfile";

const SearchResponseData = ({ responseData, setResponseData }) => {

    const [openViewProfile, setOpenViewProfile] = useState(false)
    const [profileData, setProfileData] = useState({})

    const handleViewProfile = (profileData) => {
        setOpenViewProfile(true);
        setProfileData(profileData)
    }
    return (
        <>
            <Grid container spacing={1} sx={{ mt: 2 }}>
                {responseData?.map((user, i) => (
                    <Grid item xs={12} sm={6} md={4} lg={2} key={i}>
                        <Card
                            sx={{
                                backgroundColor: "#fff",
                                borderRadius: "12px",
                                border: "1px solid #e0e0e0",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                                transition: "transform 0.2s ease",
                                "&:hover": {
                                    transform: "scale(1.02)",
                                },
                                textAlign: "center",
                                p: 2,
                            }}
                        >
                            <Avatar
                                alt={user?.name}
                                src={`data:image/*;base64, ${user?.avatar?.data}`}
                                sx={{
                                    width: 64,
                                    height: 64,
                                    mx: "auto",
                                    mb: 1,
                                    border: user?.starAlumni ? "3px solid #D89E46" : "none",
                                }}
                            />
                            <Typography variant="subtitle1" noWrap fontWeight={600}>
                                {user?.name}
                                {user?.starAlumni && (
                                    <VerifiedIcon
                                        sx={{
                                            color: "#D89E46",
                                            fontSize: "16px",
                                            ml: "4px",
                                            verticalAlign: "middle",
                                        }}
                                    />
                                )}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" noWrap>
                                {user?.programs?.name || "No Program"}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" noWrap>
                                {user?.aboutMe || "No About"}
                            </Typography>


                            <CardContent sx={{ px: 0 }}>

                                <Button
                                    onClick={() => handleViewProfile(user)}
                                    variant="outlined"
                                    fullWidth
                                    startIcon={<Person2OutlinedIcon />}
                                    sx={{ mt: 1 }}
                                >
                                    Profile
                                </Button>

                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {openViewProfile && (
                <Drawer
                    anchor="right"
                    open={openViewProfile}
                    onClose={() => setOpenViewProfile(false)}
                    sx={{
                        "& .MuiDrawer-paper": {
                            width: { xs: "60%", sm: "50%" },
                        },
                    }}
                >
                    <Box sx={{ p: 0 }}>
                        <SearchProfile
                            setViewProfile={setOpenViewProfile}
                            selectedAlumni={profileData}
                            alumniUserId={profileData?.userId}
                        />
                    </Box>
                </Drawer>
            )}
        </>
    );
};

export default SearchResponseData;
